import { useServiceUrl } from 'domain/shared/service';
import { SidebarStickyMenu, SummaryMenuItem } from 'framework/ui/menu';

const ViewServicePageMenu = () => {
  const { getSingleEntityUrl } = useServiceUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl()} />
    </SidebarStickyMenu>
  );
};

export default ViewServicePageMenu;
